<template>
	<div class="content-title">
		<div class="greeting">
			{{ theGreeting }} {{ userName ? userName : 'User Name' }}
			<SunIcon />
		</div>
		<div class="title-of-page" style="padding: 2px 0 0 0;">
			
			<a
				class="switchDashboardButton"
				id="listingDetail"
				:href="goto()"
				><IconGrid style="width: 16px;"/> <span>{{ $t('ไปที่แผงควมคุมอสังหาฯ') }} </span></a
			>
			<router-link
				class="switchDashboardButton second-button"
				id="listingDetail"
				:to="$i18nRoute({ name: '' })"
				style="color: white;"
				><IconHome style="width: 16px;color:white;"/> <span>{{ $t('มาร์เก็ตเพลส') }}</span></router-link
			>
		</div>
	</div>
</template>
<script>
// Icons
import SunIcon from '@/components/icons/IconSun/index';
import IconGrid from '@/components/icons/IconGrid/index';
import IconHome from '@/components/icons/IconHome/index';
const moment = require('moment');
import { mapGetters } from 'vuex';

export default {
	components: {
		SunIcon,
		IconGrid,
		IconHome
	},
	data() {
		return {
			theGreeting: '',
			userName: null
		};
	},
	computed: {
		...mapGetters('SiteConfigController', ['projectConfig']),
	},
	mounted() {
		this.getTimeTheGreeting();
		this.getNameUser();
	},
	methods: {
		getTimeTheGreeting() {
			const now = moment().format('H');
			if (+now >= 5 && +now < 12) {
				this.theGreeting = this.$t('greeting.morning');
			} else if (+now >= 12 && +now < 17) {
				this.theGreeting = this.$t('greeting.afternoon');
			} else {
				this.theGreeting = this.$t('greeting.evening');
			}
		},
		getNameUser() {
			var name = JSON.parse(localStorage.getItem('user_profile')).display_name;
			this.userName = name;
		},
		goto(){
			return this.projectConfig.property_url+'/th/user-dashboard';
		}
	}
};
</script>
<style lang="scss">
@import 'greeting.scss';
</style>
